import React, { useState } from 'react'
import type { DialogProps } from '../components/Dialog'
import Dialog, { DialogTitle, DialogActions, DialogContent } from '../components/Dialog'
import Button from '../components/Button'
import { makeStyles } from '@material-ui/core'
import Typography from '../components/Typography'
import Alert from '../components/Alert'

export interface ConflictResolveDialogProps extends DialogProps {
  title?: React.ReactNode
  message?: React.ReactNode
  yesLabel?: React.ReactNode
  noLabel?: React.ReactNode
  scary?: boolean
  updates?: string[]
  onConfirm?: (event: React.MouseEvent<HTMLElement>) => void
  onCancel?: (event: React.MouseEvent<HTMLElement>) => void
}

const useStyles = makeStyles((theme) => ({
  content: {
    minHeight: 100,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    [theme.breakpoints.down('sm')]: {
      alignItems: 'flex-start'
    }
  },
  scaryButton: {
    background: theme.palette.error.main
  }
}))
function ConflictResolveDialog({
  onCancel,
  onConfirm,
  title,
  message,
  yesLabel,
  noLabel,
  scary,
  updates,
  ...otherProps
}: ConflictResolveDialogProps) {
  const [loading, setLoading] = useState(false)
  const classes = useStyles(otherProps)
  async function handleConfirm(ev: any) {
    // set loading is the onConfirm is an async function
    const loadingTimeout = setTimeout(() => setLoading(true), 1)
    await onConfirm(ev)

    setLoading(false)
    // cancel the timeout if the async finished quickly / wasn't async
    clearTimeout(loadingTimeout)
  }
  const UpdatesList = updates.map((update) => {
    return <li key={update}>{update}</li>
  })

  return (
    <Dialog onClose={onCancel} {...otherProps}>
      <DialogTitle loading={loading}>{title}</DialogTitle>
      <DialogContent className={classes.content}>
        {scary ? (
          <Alert content={message} severity={'error'} variant="default" />
        ) : (
          <Typography variant="body1" component="div" align="center">
            {message}
          </Typography>
        )}
        <br />
        <Typography variant="body1" component="div" align="center">
          The following updates will be applied:
        </Typography>
        <ul>{UpdatesList}</ul>
      </DialogContent>
      <DialogActions
        leftButton={
          !!onCancel && (
            <Button disabled={loading} onClick={onCancel} variant="textNoPadding">
              {noLabel}
            </Button>
          )
        }
      >
        <Button
          disabled={loading}
          onClick={handleConfirm}
          variant={'contained'}
          className={scary ? classes.scaryButton : null}
        >
          {yesLabel}
        </Button>
      </DialogActions>
    </Dialog>
  )
}

ConflictResolveDialog.defaultProps = {
  title: 'Are you sure?',
  yesLabel: 'Ok',
  noLabel: 'Cancel'
}
export default ConflictResolveDialog
